<div class="ai-composer" [class.ai-composer--listening]="listening">
  <!-- Staged image attachments (chips with thumbnail + name + dimensions) -->
  <div class="ai-composer__attachments" *ngIf="attachments.length">
    <div class="ai-composer__attachment" *ngFor="let a of attachments; let i = index">
      <img class="ai-composer__thumb" [src]="a.dataUrl" alt="" />
      <span class="ai-composer__att-name" [title]="a.name">{{ a.name }}</span>
      <span class="ai-composer__att-dims" *ngIf="a.width">{{ a.width }}×{{ a.height }}</span>
      <button type="button" class="ai-composer__att-remove" aria-label="Remove image" [disabled]="disabled" (click)="removeAttachment(i)">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <textarea
    #input
    class="ai-composer__input"
    rows="1"
    [(ngModel)]="text"
    [disabled]="disabled"
    (input)="onInput()"
    (paste)="onPaste($event)"
    (keydown)="onKeydown($event)"
    [placeholder]="listening ? 'Listening…' : 'Ask Remmi…'"></textarea>

  <input #fileInput type="file" accept="image/*" multiple hidden (change)="onFilesSelected($event)" />

  <div class="ai-composer__toolbar">
    <button type="button" class="ai-composer__add" title="New chat" aria-label="New chat" [disabled]="disabled" (click)="newChat.emit()">
      <i class="pi pi-plus"></i>
    </button>

    <div class="ai-composer__tools">
      <button
        *ngIf="attachEnabled"
        type="button"
        class="ai-composer__attach"
        title="Attach image"
        aria-label="Attach image"
        [disabled]="disabled"
        (click)="openFilePicker()">
        <i class="pi pi-image"></i>
      </button>

      <button
        *ngIf="voiceSupported"
        type="button"
        class="ai-composer__mic"
        [class.ai-composer__mic--on]="listening"
        [disabled]="disabled"
        [attr.aria-label]="listening ? 'Stop voice input' : 'Start voice input'"
        (click)="toggleVoice()">
        <i class="pi" [ngClass]="listening ? 'pi-stop-circle' : 'pi-microphone'"></i>
      </button>

      <button type="button" class="ai-composer__send" [disabled]="!canSend" aria-label="Send" (click)="submit()">
        <i class="pi pi-send"></i>
      </button>
    </div>
  </div>
</div>
